import { Link } from "react-router-dom";
import { Calculator, TrendingDown, ArrowLeftRight, ArrowRight } from "lucide-react";
import SEO from "../ui/SEO.jsx";

const calculadoras = [
  {
    to: "/calculadoras/salario",
    icon: <Calculator size={24} />,
    title: "Salário líquido",
    description:
      "Quanto você recebe na conta depois de shakai/kokumin hoken, imposto de renda e imposto residencial. Inclui equivalente em reais no poder de compra de São Paulo.",
    inputs: "5 perguntas · 30 segundos",
  },
  {
    to: "/calculadoras/aposentadoria",
    icon: <TrendingDown size={24} />,
    title: "Dattai ichijikin",
    description:
      "Estimativa do reembolso da aposentadoria quando você sai do Japão. Calcula o valor bruto, o desconto de 20,42% e quanto pode ser recuperado via representante fiscal.",
    inputs: "3 perguntas · 20 segundos",
  },
  {
    to: "/calculadoras/remessas",
    icon: <ArrowLeftRight size={24} />,
    title: "Comparar remessas",
    description:
      "Compare quanto chega no Brasil pelas principais opções: Wise, Brastel, GoRemit e outras. Inclui taxa de câmbio + tarifa fixa de cada serviço.",
    inputs: "Insira valor · resultado imediato",
  },
];

export default function Calculadoras() {
  return (
    <div>
      <SEO
        title="Calculadoras"
        description="Calculadoras para brasileiros no Japão: salário líquido, dattai ichijikin (aposentadoria), comparação de remessas."
        path="/calculadoras"
      />
      
      <div className="text-[11px] tracking-[0.18em] uppercase text-accent mb-4 font-semibold">
        Ferramentas
      </div>
      <h1 className="font-serif font-medium text-4xl md:text-5xl leading-tight tracking-tight mb-4">
        Calculadoras
      </h1>
      <p className="text-lg text-ink-soft leading-relaxed max-w-xl mb-10">
        Use estas ferramentas para tomar decisões mais informadas. Todas
        baseadas em tabelas oficiais de 2025–2026, com fórmulas abertas
        para você conferir.
      </p>

      <div className="space-y-4">
        {calculadoras.map((c) => (
          <Link
            key={c.to}
            to={c.to}
            className="flex items-start gap-5 p-6 md:p-7 rounded-2xl border border-border bg-surface hover:border-accent transition-colors no-underline text-ink group"
          >
            <div className="w-12 h-12 rounded-xl bg-accent-soft flex items-center justify-center text-accent shrink-0">
              {c.icon}
            </div>
            <div className="flex-1">
              <div className="flex items-center justify-between gap-3">
                <h2 className="font-serif text-2xl font-medium group-hover:text-accent transition-colors">
                  {c.title}
                </h2>
                <ArrowRight size={20} className="text-ink-soft group-hover:text-accent transition-colors shrink-0" />
              </div>
              <p className="text-[15px] text-ink-soft leading-relaxed mt-2 mb-3">
                {c.description}
              </p>
              <span className="text-xs font-mono text-ink-soft">{c.inputs}</span>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
